<template lang="pug">
  v-popover.inline-block.cursor-pointer(:placement="placement" trigger="hover" :popover-base-class="[popoverBaseClasses, customClasses]")
    slot
    .relative.py-1.px-2(slot="popover")
      .px-0.text-white
        slot(name="tooltip-content")
</template>

<script>
import { VPopover } from 'v-tooltip';

export default {
  name: 'SwTooltip',
  components: {
    VPopover,
  },
  props: {
    placement: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value),
    },
    customClasses: {
      type: String,
      default: 'bg-gray-700 text-gray-700',
    },
  },
  computed: {
    popoverBaseClasses () {
      return 'tooltip rounded-sm m-3 relative border-4 border-current shadow-md';
    },
  },
};
</script>

<style lang="scss">
  .tooltip {
    .tooltip-arrow {
      @apply text-current border-8 absolute border-transparent block;
    }
    &[x-placement="left"] .tooltip-arrow {
      @apply border-l-current border-r-0 border-l-12 -right-4 top-1/2 -ml-4;
    }
    &[x-placement="right"] .tooltip-arrow {
      @apply border-r-current border-l-0 border-r-12 top-1/2 -ml-4;
    }
    &[x-placement="bottom"] .tooltip-arrow {
      @apply border-b-current border-t-0 border-b-12 -top-4 left-1/2 -mb-4;
    }
    &[x-placement="top"] .tooltip-arrow {
      @apply border-t-current border-b-0 border-t-12 bottom-0 left-1/2 -mb-4;
    }
  }
</style>
